export default __webpack_public_path__ + "static/media/Reddit6.ab4e28d3.PNG";